import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = ["disabled", "onClick"]
const _hoisted_2 = { class: "button-text" }

import { ref, computed, onMounted } from "vue";
import type { Applicant } from "@/models/application";
import type { Stipulation } from "@/models/opal";
import { useStore } from "vuex";
import { IncomeVerificationRequest as AutomatedIncomeVerificationRequest } from "@/models/api";
import { type Button, type ModalOptions, ButtonTypes } from "@/models/modal";
import { $api } from "@/services/api";
import Modal from "@/components/shared/Modal.vue";

interface Props {
  stip: Stipulation;
  applicant: Applicant;
  manualCertification: boolean;
  employments?: string[];
}


export default /*@__PURE__*/_defineComponent({
  __name: 'ConfirmManualncomeVerificationModal',
  props: {
    stip: {},
    applicant: {},
    manualCertification: { type: Boolean },
    employments: {}
  },
  emits: ["close", "confirm"],
  setup(__props: any, { expose: __expose, emit: __emit }) {

const store = useStore();

const props = __props;

const footerBtns = ref<HTMLDivElement | null>(null);

const emit = __emit;

const isActive = ref<boolean>(false);
const loading = ref<boolean>(false);
const error = ref<boolean>(false);

const isBtnLoading = (button: Button) => {
  return button.type === ButtonTypes.Confirm ? loading.value : false;
};

const openModal = () => {
  console.log("open modal");

  loading.value = false;
  isActive.value = true;
  store.dispatch("modal/openConfirmManualIncomeVerificationModal");
  disableButtons(false);
};

const closeModal = () => {
  isActive.value = false;
  loading.value = false;

  store.dispatch("modal/closeConfirmManualIncomeVerificationModal");

  disableButtons(false);
};

function disableButtons(flag: boolean) {
  const btns = footerBtns.value?.querySelectorAll("button");
  btns?.forEach((button: HTMLButtonElement) => {
    button.disabled = flag;
  });
}

const modalBtns = ref<Array<Button>>([
  {
    label: "Cancel",
    classStyle: "btn btn-light px-16 py-11 flex-grow-1",
    type: ButtonTypes.Cancel,
    onClick: () => {
      closeModal();
    },
  },
  {
    label: "I understand",
    classStyle: "btn btn-primary px-16 py-11 flex-grow-1",
    type: ButtonTypes.Confirm,
    onClick: async () => {
      emit("confirm");
      disableButtons(true);
      await handleAutomatedIncomeVerificationConsent();
    },
  },
]);

const modalOptions = ref<ModalOptions>({
  title: "Are you sure you want to verify your income manually?",
  description:
    "By declining the option to verify your income electronically, you will not be given the option to do so again.",
  buttons: modalBtns.value,
});

const request = computed<AutomatedIncomeVerificationRequest>(() => {
  return {
    applicationId: store.state?.appData?.application?.id,
    lenderId: store.state?.appData?.application?.lenderId,
    programTypeId: store.state?.appData?.application?.programTypeId,
    productTypeId: store.state?.appData?.application?.productTypeId,
    stipulationId: props.stip.id,
    consent: props.manualCertification === false,
    employments: props.employments,
  };
});

async function handleAutomatedIncomeVerificationConsent() {
  loading.value = true;
  error.value = false;

  await $api.income
    .addIncomeVerificationConsent(request.value)
    .then(async response => {
      console.log("consent added", response);

      if (props.manualCertification) {
        closeModal();
        disableButtons(false);
      }

      // Get latest stips
      await store.dispatch("checklistModule/getSortedChecklistItems");

      // Get latest applicant survey responses
      await store.dispatch("getApplicantSurveyResponses", props.applicant?.id);
    })
    .catch(err => {
      error.value = true;
      console.log("Error adding automated income verification consent", err);
    })
    .finally(() => {
      console.log("");
    });

  loading.value = false;
}

onMounted(() => {
  // Reset buttons
  loading.value = false;
  disableButtons(false);
});

__expose({
  isActive,
  loading,
  error,
  openModal,
  closeModal,
  disableButtons,
  handleAutomatedIncomeVerificationConsent,
});

return (_ctx: any,_cache: any) => {
  return (isActive.value)
    ? (_openBlock(), _createBlock(Modal, {
        key: 0,
        class: "confirm-manual-income-verification-modal",
        allowClose: true,
        onClose: closeModal
      }, {
        header: _withCtx(() => [
          _createTextVNode(_toDisplayString(modalOptions.value.title), 1)
        ]),
        footer: _withCtx(() => [
          _createElementVNode("div", {
            class: "footer-btns",
            ref_key: "footerBtns",
            ref: footerBtns
          }, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(modalOptions.value.buttons, (button, index) => {
              return (_openBlock(), _createElementBlock("button", {
                key: index,
                class: _normalizeClass([button?.classStyle, { 'is-loading': isBtnLoading(button) }]),
                disabled: loading.value,
                onClick: button?.onClick
              }, [
                _createElementVNode("span", _hoisted_2, _toDisplayString(button?.label), 1)
              ], 10, _hoisted_1))
            }), 128))
          ], 512)
        ]),
        default: _withCtx(() => [
          _createElementVNode("div", null, _toDisplayString(modalOptions.value.description), 1)
        ]),
        _: 1
      }))
    : _createCommentVNode("", true)
}
}

})